<template>
  <div class="all_part">
    <div>
      <titleBlock_computer></titleBlock_computer>
    </div>
    <div class="input_button">
      <div class="all_input">
        <div class="all_input_top" v-if="PanDuanShou">
          <div>
            <el-select
              v-model="ChanPinDaLei_choice"
              placeholder="请选择产品大类"
              style="width: 290px"
            >
              <el-option
                v-for="item in ChanPinDaLei_Select"
                :key="item.value"
                :label="item.category"
                :value="item.id"
                @click="this.serchChanPinXiaoLei()"
              >
              </el-option>
            </el-select>
          </div>
          <div>
            <el-select
              v-model="ChanPinXiaoLei_choice"
              placeholder="请选择产品小类"
              style="width: 290px"
            >
              <el-option
                v-for="item in ChanPinXiaoLei_Select"
                :key="item.value"
                :label="item.title"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </div>
          <div>
            <el-select
              v-model="CaiZhi_choice"
              placeholder="请选择材质"
              style="width: 290px"
            >
              <el-option
                v-for="item in CaiZhi_select"
                :key="item.value"
                :label="item.title"
                :value="item.title"
              >
              </el-option>
            </el-select>
          </div>
          <div>
            <el-input
              v-model="newItemNo"
              placeholder="请输入新料号"
              style="width: 290px"
            ></el-input>
          </div>
          <div>
            <el-input
              v-model="oldMaterialNo"
              placeholder="请输入旧料号"
              style="width: 290px"
            ></el-input>
          </div>
          <div>
            <el-input
              v-model="inquiry_no"
              placeholder="请输入询价单号"
              style="width: 290px"
            ></el-input>
          </div>
          <!--          <div>-->

          <!--            <div>-->
          <!--              <el-input-->
          <!--                  v-model="wire_diameter"-->
          <!--                  placeholder="请输入线径"-->
          <!--                  style="width: 290px"-->
          <!--              ></el-input>-->
          <!--            </div>-->
          <!--          </div>-->
          <!--          <div>-->
          <!--            <div>-->
          <!--              <el-input-->
          <!--                  v-model="internal_meridian"-->
          <!--                  placeholder="请输入内径"-->
          <!--                  style="width: 290px"-->
          <!--              ></el-input>-->
          <!--            </div>-->
          <!--            <div>-->
          <!--              <el-select v-model="BiaoZhun_Choice" placeholder="请选择标准" style="width: 290px">-->
          <!--                <el-option-->
          <!--                    v-for="item in BiaoZhun_Select"-->
          <!--                    :key="item.value"-->
          <!--                    :label="item.standard"-->
          <!--                    :value="item.standard"-->
          <!--                >-->
          <!--                </el-option>-->
          <!--              </el-select>-->
          <!--            </div>-->
          <!--            <div>-->
          <!--              <el-select v-model="YanSe_Choice" placeholder="请选择颜色" style="width: 290px">-->
          <!--                <el-option-->
          <!--                    v-for="item in YanSe_Select"-->
          <!--                    :key="item.value"-->
          <!--                    :label="item.color"-->
          <!--                    :value="item.color"-->
          <!--                >-->
          <!--                </el-option>-->
          <!--              </el-select>-->
          <!--            </div>-->
          <!--          </div>-->
          <!--          <div>-->
          <!--            <div>-->
          <!--              <el-select v-model="CaiLiaoXinXi_Code_Choice" placeholder="请选择材料信息代码" style="width: 290px">-->
          <!--                <el-option-->
          <!--                    v-for="item in CaiLiaoXinXi_Code_Select"-->
          <!--                    :key="item.value"-->
          <!--                    :label="item.title"-->
          <!--                    :value="item.title"-->
          <!--                >-->
          <!--                </el-option>-->
          <!--              </el-select>-->
          <!--            </div>-->
          <!--            <div>-->
          <!--              <el-select v-model="YingDu_Choice" placeholder="请选择硬度" style="width: 290px">-->
          <!--                <el-option-->
          <!--                    v-for="item in YingDu_Select"-->
          <!--                    :key="item.value"-->
          <!--                    :label="item.hardness"-->
          <!--                    :value="item.hardness"-->
          <!--                >-->
          <!--                </el-option>-->
          <!--              </el-select>-->
          <!--            </div>-->
          <!--            <div>-->
          <!--              <el-input-->
          <!--                  v-model="standard_code"-->
          <!--                  placeholder="请输入标准代码"-->
          <!--                  style="width: 290px"-->
          <!--              ></el-input>-->
          <!--            </div>-->
          <!--          </div>-->
        </div>
      </div>
      <div class="submit_button">
        <!-- <div class="search_button">
          <el-button type="primary" @click="TianJiaZhanShi" style="height: 48px; width: 144px"
          >报价筛选
          </el-button
          >
        </div> -->
        <div class="search_button">
          <div class="sousuoButton">
            <el-button
              type="primary"
              @click="serchChanPin"
              style="
                height: 48px;
                width: 144px;
                margin-left: 20px;
                font-size: 16px;
              "
              >高级搜索
            </el-button>
            <div class="icon_sou">
              <img src="../assets/SouSuo.png" alt="" width="14px" />
            </div>
          </div>
        </div>
        <div class="all_second_button">
          <div class="ChongZhi">
            <div class="second_button" @click="clearInput">
              <el-button
                plain
                type="primary"
                style="width: 92px; height: 48px; font-size: 16px"
                >重置
              </el-button>
            </div>
            <div class="icon_chong">
              <img src="../assets/ChongZhi.png" alt="" width="14px" />
            </div>
          </div>
          <div class="second_button">
            <div class="ShouQi">
              <div>
                <el-button
                  plain
                  type="primary"
                  style="width: 92px; height: 48px; font-size: 16px"
                  @click="inputShow"
                >
                  {{ PanDuanShou ? "收起" : "展开" }}
                </el-button>
              </div>
              <div :class="PanDuanShou ? 'icon_Shou' : 'icon_Shous'">
                <img src="../assets/ShouQI.png" alt="" width="14px" />
              </div>
            </div>
          </div>
          <div class="second_button" @click="clearInput">
            <div class="Fanhu">
              <div>
                <el-button
                  plain
                  type="primary"
                  style="width: 92px; height: 48px"
                  @click="back_menu"
                  >返回
                </el-button>
              </div>
              <div class="icon_fan">
                <img src="../assets/FanHui.png" alt="" width="14px" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="table">
      <el-table :data="tableData" style="width: 100%" height="580" border>
        <!--        <el-table-column fixed prop="date" label="编号" width="90" type="index">-->
        <!--        </el-table-column>-->
        <el-table-column
          prop="product_number"
          label="平台产品编号"
          width="160"
        ></el-table-column>
        <el-table-column
          prop="newItemNo"
          label="新料号"
          width="160"
        ></el-table-column>
        <el-table-column
          prop="oldMaterialNo"
          label="旧料号"
          width="160"
        ></el-table-column>
        <el-table-column
          prop="category"
          label="产品大类"
          width="160"
        ></el-table-column>
        <el-table-column
          prop="inquiry_no"
          label="询价单号"
          width="160"
        ></el-table-column>

        <el-table-column
          prop="discount_category"
          label="折扣类别"
          width="160"
        ></el-table-column>
        <el-table-column
          prop="product_category"
          label="产品类别"
          width="160"
        ></el-table-column>
        <el-table-column
          prop="product_category_small"
          label="产品小类"
          width="160"
        ></el-table-column>
        <el-table-column
          prop="material"
          label="材质"
          width="160"
        ></el-table-column>
        <el-table-column
          prop="dimension_description"
          label="尺寸描述"
          width="160"
        ></el-table-column>
        <el-table-column
          prop="material_description"
          label="材质描述"
          width="160"
        ></el-table-column>

        <el-table-column
          prop="describe"
          label="描述"
          width="320"
        ></el-table-column>
      </el-table>
    </div>
    <div class="block">
      <el-pagination
        layout="prev, pager, next"
        :total="total"
        hide-on-single-page="true"
        @current-change="reflash"
      >
      </el-pagination>
    </div>
    <div class="Copyright_information">
      <span>Copyright © 胤舜密封EBD数据平台限内部使用 版权所有</span>
    </div>
  </div>
</template>
<script>
import titleBlock_computer from "../views/titleBlock_computer.vue";
import { httpUrl } from "../components/publics";

export default {
  data() {
    return {
      total: "",
      PanDuanShou: false,
      tableData: [],
      newItemNo: "", //新料号
      oldMaterialNo: "", //旧料号
      CaiZhi_choice: "", //材质选择   //material
      ChanPinXiaoLei_choice: "", //产品小类选择
      ChanPinDaLei_choice: "", // 产品大类选择
      inquiry_no: "", //询价单号
      internal_meridian: "", // 产品内径
      wire_diameter: "", //产品线径
      BiaoZhun_Choice: "", //标准选择
      YingDu_Choice: "", //硬度选择
      standard_code: "", //标准代码

      CaiLiaoXinXi_Code_Choice: "", //材料信息选择

      YanSe_Choice: "", //颜色选择
      ChanPinDaLei_Select: [], // 产品大类下拉框
      ChanPinXiaoLei_Select: [], //产品小类下拉框
      CaiZhi_select: [], //材质选择拉下
      BiaoZhun_Select: [], //标准下拉框
      YingDu_Select: [], //硬度下拉框
      CaiLiaoXinXi_Code_Select: [], //材料信息下拉框
      YanSe_Select: [], //颜色下拉框
      page: "",
    };
  },
  watch: {
    ChanPinDaLei_choice(newName, oldName) {
      this.serchChanPinXiaoLei(newName);
    },
    ChanPinXiaoLei_choice() {
      this.serchCaiZhi();
    },
  },
  mounted() {
    this.serchChanPinDaLei();
    this.serchBiaoZhun();
    this.serchYingDu();
    this.serchCaiLiaoXinxi();
    this.serchYanSe();
  },

  methods: {
    clearInput() {
      this.newItemNo = ""; //新料号
      this.oldMaterialNo = ""; //旧料号
      this.internal_meridian = ""; // 产品内径
      this.wire_diameter = ""; //产品线径
      this.ChanPinXiaoLei_choice = ""; //产品小类选择
      this.CaiZhi_choice = ""; //材质选择   //material
      this.BiaoZhun_Choice = ""; //标准选择
      this.YingDu_Choice = ""; //硬度选择
      this.standard_code = ""; //标准代码
      this.inquiry_no = ""; //询价单号
      this.CaiLiaoXinXi_Code_Choice = ""; //材料信息选择
      this.ChanPinDaLei_choice = ""; // 产品大类选择
      this.YanSe_Choice = ""; //颜色选择
      this.customer_drawing = ""; //客户图号选择
      this.special_process = ""; //特殊工艺选择
      this.dimension_description = ""; //尺寸描述
      this.material_description = ""; //材质描述
      this.structural = ""; //结构形式选择
    },
    back_menu() {
      this.$router.push("/second_menuComputer_ICProductInfo");
    },
    inputShow() {
      if (this.PanDuanShou) {
        this.PanDuanShou = !this.PanDuanShou;
      } else {
        this.PanDuanShou = !this.PanDuanShou;
      }
    },
    reflash(val) {
      console.log(1);
      console.log(this.page + 1);
      this.page = val;
      this.serchChanPin();
    },
    serchBiaoZhun() {
      this.axios
        .get(httpUrl + `/api/index/standard`)
        .then((response) => {
          if (response.data.code == 200) {
            this.BiaoZhun_Select = response.data.data;
            console.log(this.tableData.data);
          }
          // this.$message("搜索成功");
          console.log("success", response.data);
        })
        .catch((error) => console.log(error, "error"));
    },
    serchYingDu() {
      this.axios
        .get(httpUrl + `/api/index/hardness`)
        .then((response) => {
          if (response.data.code == 200) {
            this.YingDu_Select = response.data.data;
            console.log(this.tableData.data);
          }
          // this.$message("搜索成功");
          console.log("success", response.data);
        })
        .catch((error) => console.log(error, "error"));
    },
    serchCaiLiaoXinxi() {
      this.axios
        .get(httpUrl + `/api/index/material_number`)
        .then((response) => {
          if (response.data.code == 200) {
            this.CaiLiaoXinXi_Code_Select = response.data.data;
            console.log(this.tableData.data);
          }
          // this.$message("搜索成功");
          console.log("success", response.data);
        })
        .catch((error) => console.log(error, "error"));
    },
    serchYanSe() {
      this.axios
        .get(httpUrl + `/api/index/colorOffer`)
        .then((response) => {
          if (response.data.code == 200) {
            this.YanSe_Select = response.data.data;
            console.log(this.tableData.data);
          }
          // this.$message("搜索成功");
          console.log("success", response.data);
        })
        .catch((error) => console.log(error, "error"));
    },
    serchCaiZhi() {
      this.axios
        .get(
          httpUrl +
            `/api/index/non_standard_material?supplier_id=${this.ChanPinDaLei_choice}&non_standard_category_id=${this.ChanPinXiaoLei_choice}`
        )
        .then((response) => {
          if (response.data.code == 200) {
            this.CaiZhi_select = response.data.data;
            console.log(this.tableData.data);
          }
          // this.$message("搜索成功");
          console.log("success", response.data);
        })
        .catch((error) => console.log(error, "error"));
    },
    serchChanPinXiaoLei(val) {
      this.axios
        .get(
          httpUrl +
            `/api/index/non_standard_category?supplier_id=${val}`
        )
        .then((response) => {
          if (response.data.code == 200) {
            this.ChanPinXiaoLei_Select = response.data.data;
            console.log(this.tableData.data);
          }
          // this.$message("搜索成功");
          console.log("success", response.data);
        })
        .catch((error) => console.log(error, "error"));
    },
    serchChanPinDaLei() {
      this.axios
        .get(httpUrl + `/api/index/non_category`)
        .then((response) => {
          if (response.data.code == 200) {
            this.ChanPinDaLei_Select = response.data.data;
            console.log(this.tableData.data);
          }
          // this.$message("搜索成功");
          console.log("success", response.data);
        })
        .catch((error) => console.log(error, "error"));
    },
    serchChanPin() {
      let suser_id = JSON.parse(sessionStorage.getItem("user"));
      let selectID = suser_id.id;
      console.log(selectID);
      this.axios
        .get(
          httpUrl +
            `/api/index/non_standard?newItemNo=${this.newItemNo}&oldMaterialNo=${this.oldMaterialNo}&material=${this.CaiZhi_choice}&category_small=${this.ChanPinXiaoLei_choice}&category_big=${this.ChanPinDaLei_choice}&inquiry_no=${this.inquiry_no}&page=${this.page}`
        )
        .then((response) => {
          if (response.data.code == 200) {
            this.total = response.data.data.total;
            this.tableData = response.data.data.data;
          }
          // this.$message("搜索成功");
          this.$message(response.data.message);
        })
        .catch((error) => console.log(error, "error"));
    },
  },
  components: {
    titleBlock_computer,
  },
};
</script>

<style>
</style>
<style scoped>
.all_part {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100vh;
}

.all_input {
  display: flex;
  flex-direction: column;
  padding: 0 20px;
}

.all_input_top {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: 10px 0;
}

.all_input_bottom {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.submit_button {
  margin-top: 20px;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}

.all_second_button {
  display: flex;
  flex-direction: row;
  margin-right: 20px;
}

.second_button {
  margin-left: 20px;
}

.Copyright_information {
  margin-bottom: 15px;
}
.sousuoButton {
  position: relative;
}
.icon_sou {
  top: 16px;
  left: 40px;
  position: absolute;
}
.ChongZhi {
  position: relative;
}
.icon_chong {
  top: 16px;
  left: 32px;
  position: absolute;
}
.ShouQi {
  position: relative;
}
.icon_Shou {
  top: 14px;
  left: 12px;

  position: absolute;
}
.icon_Shous {
  top: 15px;
  left: 12px;
  position: absolute;
  transform: rotate(180deg);
}
.icon_fan {
  top: 16px;
  left: 12px;
  position: absolute;
}
.Fanhu {
  position: relative;
}
</style>